<template>
  <div style="padding-left: 24px; padding-right: 48px;" class="py-3">
    <v-layout row>
      <v-flex xs2 sm1 class="align-self-center"
              :class="{'pl-3': $vuetify.breakpoint.smAndUp}">
        <v-icon medium>mdi-alarm</v-icon>
      </v-flex>
      <v-flex     sm2 v-if="$vuetify.breakpoint.smAndUp">
        {{$t('alert')}}
      </v-flex>
      <v-flex xs5     v-if="$vuetify.breakpoint.xsOnly">
        <div>{{alert.alert.name}}</div>
      </v-flex>
      <v-flex xs5 sm2>
        {{alert.alertDate | date}}
      </v-flex>
      <v-flex     sm5 v-if="$vuetify.breakpoint.smAndUp">
        <div>{{alert.alert.name}}</div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'

  export default {
    name: 'student-alert-row',
    props: ['alert'],
    mixins: [DateFormat],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>
  .align-self-center {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/alert/StudentAlertRow.vue